<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/Page-header";
import CheckModal from "@/components/CheckModal";
import DocumentActions from "@/components/document/DocumentActions.vue";
import authorityRequirementAPI from "@/services/standards/authorityRequirement/authorityRequirementAPI";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import newScoresAPI from "@/services/newScores/newScoresAPI";
import Swal from "sweetalert2";

function blankAction() {
  return { accion: "", responsable: "", fecha_inicio: null, fecha_fin: null, recursos: "", estado: "Pendiente", evidencia_file: null, _uploading: false };
}

export default {
  page: { title: "Requerimiento de Autoridad/ARL" },
  components: { Layout, PageHeader, CheckModal, DocumentActions },
  data() {
    return {
      title: "7.1.4 Implementación de Medidas y Acciones Correctivas de Autoridades y ARL",
      items: [
        { text: "Estándares", href: "/forms/estandares" },
        { text: "7.1.4 Requerimientos de autoridades y ARL", active: true },
      ],
      companyID: this.$store.getters["company/getCompany"].id || null,
      nit: this.$store.getters["company/getCompany"].nit || null,
      recordId: this.$route.params.record || null,
      catalog: { entidades: [], tipos_hallazgo: [], metodos_causa: [], estados: [], eficacias: [], evidencias: [] },
      form: {
        centro_trabajo: null, responsable_sgsst: null, cargo: null, fecha: new Date().toISOString().substring(0, 10),
        entidad: null, oficio: null, fecha_requerimiento: null, fecha_limite: null,
        hallazgo_numero: null, tipo_hallazgo: null, descripcion: null, norma_relacionada: null, evidencia_autoridad: null,
        metodo_causa: null, analisis_causa: null,
        eficacia: null, eficacia_justificacion: null, evidencias: [],
        fecha_cierre: null, responsable_cierre: null, cargo_cierre: null, observaciones: null, estado: "Pendiente",
      },
      actions: [blankAction()],
      workflowStatus: "draft",
      signedAt: null,
      submitting: false,
      loading: true,
    };
  },
  computed: {
    isSigned() { return this.workflowStatus === "signed"; },
    recordApi() {
      return {
        pdfUrl: (id) => authorityRequirementAPI.pdfUrl(id),
        sign: (id, payload) => authorityRequirementAPI.sign(id, payload),
      };
    },
  },
  methods: {
    goBack() { this.$router.go(-1); },
    addAction() { if (!this.isSigned) this.actions.push(blankAction()); },
    removeAction(idx) {
      if (this.isSigned) return;
      this.actions.splice(idx, 1);
      if (!this.actions.length) this.actions.push(blankAction());
    },
    fileName(url) { return String(url).split("/").pop(); },
    load() {
      if (!this.recordId) { this.loading = false; return; }
      authorityRequirementAPI.get(this.recordId)
        .then((r) => {
          if (!r) { this.loading = false; return; }
          ["centro_trabajo","responsable_sgsst","cargo","fecha","entidad","oficio","fecha_requerimiento","fecha_limite","hallazgo_numero","tipo_hallazgo","descripcion","norma_relacionada","evidencia_autoridad","metodo_causa","analisis_causa","eficacia","eficacia_justificacion","fecha_cierre","responsable_cierre","cargo_cierre","observaciones","estado"].forEach((f) => {
            if (r[f] !== undefined && r[f] !== null) {
              this.form[f] = ["fecha","fecha_requerimiento","fecha_limite","fecha_cierre"].includes(f) ? String(r[f]).substring(0, 10) : r[f];
            }
          });
          this.form.evidencias = Array.isArray(r.evidencias) ? r.evidencias : [];
          this.actions = (r.actions && r.actions.length)
            ? r.actions.map((a) => ({ ...blankAction(), ...a, fecha_inicio: a.fecha_inicio ? String(a.fecha_inicio).substring(0, 10) : null, fecha_fin: a.fecha_fin ? String(a.fecha_fin).substring(0, 10) : null }))
            : [blankAction()];
          this.workflowStatus = r.workflow_status || "draft";
          this.signedAt = r.signed_at || null;
          this.loading = false;
        })
        .catch((e) => { console.log(e); this.loading = false; });
    },
    save() {
      if (this.isSigned) return;
      this.submitting = true;
      const payload = { companies_id: this.companyID, ...this.form, actions: this.actions };
      const req = this.recordId ? authorityRequirementAPI.update(this.recordId, payload) : authorityRequirementAPI.save(payload);
      req
        .then((res) => {
          newScoresAPI.calculateScores({ companies_id: this.companyID, item_id: 60, status: "Pendiente" }).catch(() => {});
          Swal.fire({ title: "¡Éxito!", text: "Requerimiento guardado.", icon: "success", timer: 1600, showConfirmButton: false });
          this.submitting = false;
          if (!this.recordId && res && res.id) {
            this.recordId = res.id;
            this.$router.replace({ path: `/forms/estandares/${this.companyID}/requerimiento-autoridad/${res.id}` });
            this.load();
          }
        })
        .catch((e) => { console.log(e); this.submitting = false; Swal.fire("Error", "No se pudo guardar el requerimiento", "error"); });
    },
    async onActionEvidence(action, event) {
      if (this.isSigned) return;
      const file = event.target.files[0];
      if (!file) return;
      action._uploading = true;
      try {
        const base = process.env.VUE_APP_ENV === "development" ? "sst-dev" : "sst-prod";
        const path = `${base}/${this.nit}/7.1.4/registro-evidencias/${this.recordId || "nuevo"}/${Date.now()}_${file.name}`;
        const ok = await uploadDocument(path, file);
        if (!ok) throw new Error("upload");
        action.evidencia_file = `${process.env.VUE_APP_BUCKET}/${path}`;
        Swal.fire({ title: "Evidencia cargada", icon: "success", timer: 1200, showConfirmButton: false });
      } catch (e) {
        console.log(e);
        Swal.fire("Error", "No se pudo cargar la evidencia", "error");
      } finally {
        action._uploading = false;
        if (event.target) event.target.value = null;
      }
    },
    removeActionEvidence(action) { if (!this.isSigned) action.evidencia_file = null; },
    onSigned(payload) {
      this.workflowStatus = payload.workflow_status;
      this.signedAt = payload.signed_at;
    },
  },
  mounted() {
    authorityRequirementAPI.catalog().then((c) => { if (c) this.catalog = { ...this.catalog, ...c }; });
    this.load();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-9" v-if="!loading">
        <div class="card">
          <div class="card-body">
            <CheckModal>
              <p class="text-justify">
                Registra la implementación de las medidas y acciones correctivas derivadas de un requerimiento emitido
                por una autoridad competente (Ministerio de Trabajo, Secretaría de Salud, etc.) o por la ARL. Documenta
                la autoridad y el requerimiento, el análisis de causa, el plan de acción/implementación, la verificación
                de eficacia, las evidencias y el cierre. Cada registro puede firmarse; los registros quedan como
                historial en el tiempo. La matriz de seguimiento consolida todos los requerimientos.
              </p>
            </CheckModal>

            <div v-if="isSigned" class="alert alert-success py-2 my-2 small">
              🔒 Este registro ya fue firmado; los datos quedan bloqueados.
            </div>

            <form @submit.prevent="save">
              <h5 class="mt-2">1. Información general y autoridad</h5>
              <div class="form-row">
                <b-form-group class="col-md-4 px-2" label="Centro de trabajo"><b-form-input v-model="form.centro_trabajo" :disabled="isSigned" size="sm" /></b-form-group>
                <b-form-group class="col-md-4 px-2" label="Responsable SG-SST"><b-form-input v-model="form.responsable_sgsst" :disabled="isSigned" size="sm" /></b-form-group>
                <b-form-group class="col-md-2 px-2" label="Cargo"><b-form-input v-model="form.cargo" :disabled="isSigned" size="sm" /></b-form-group>
                <b-form-group class="col-md-2 px-2" label="Fecha"><b-form-input type="date" v-model="form.fecha" :disabled="isSigned" size="sm" /></b-form-group>
              </div>
              <div class="form-row">
                <b-form-group class="col-md-3 px-2" label="Entidad que emite">
                  <b-form-select v-model="form.entidad" :disabled="isSigned" size="sm">
                    <b-form-select-option :value="null">Seleccione...</b-form-select-option>
                    <b-form-select-option v-for="e in catalog.entidades" :key="e" :value="e">{{ e }}</b-form-select-option>
                  </b-form-select>
                </b-form-group>
                <b-form-group class="col-md-3 px-2" label="N° de oficio"><b-form-input v-model="form.oficio" :disabled="isSigned" size="sm" /></b-form-group>
                <b-form-group class="col-md-3 px-2" label="Fecha del requerimiento"><b-form-input type="date" v-model="form.fecha_requerimiento" :disabled="isSigned" size="sm" /></b-form-group>
                <b-form-group class="col-md-3 px-2" label="Fecha límite"><b-form-input type="date" v-model="form.fecha_limite" :disabled="isSigned" size="sm" /></b-form-group>
              </div>

              <h5 class="mt-2">2. Descripción del requerimiento</h5>
              <div class="form-row">
                <b-form-group class="col-md-3 px-2" label="N° del hallazgo"><b-form-input v-model="form.hallazgo_numero" :disabled="isSigned" size="sm" /></b-form-group>
                <b-form-group class="col-md-3 px-2" label="Tipo">
                  <b-form-select v-model="form.tipo_hallazgo" :disabled="isSigned" size="sm">
                    <b-form-select-option :value="null">Seleccione...</b-form-select-option>
                    <b-form-select-option v-for="t in catalog.tipos_hallazgo" :key="t" :value="t">{{ t }}</b-form-select-option>
                  </b-form-select>
                </b-form-group>
                <b-form-group class="col-md-6 px-2" label="Norma relacionada"><b-form-input v-model="form.norma_relacionada" :disabled="isSigned" size="sm" /></b-form-group>
                <b-form-group class="col-md-6 px-2" label="Descripción"><b-form-textarea v-model="form.descripcion" :disabled="isSigned" rows="2" /></b-form-group>
                <b-form-group class="col-md-6 px-2" label="Evidencia entregada por la autoridad"><b-form-textarea v-model="form.evidencia_autoridad" :disabled="isSigned" rows="2" /></b-form-group>
              </div>

              <h5 class="mt-2">3. Análisis de causa</h5>
              <div class="form-row">
                <b-form-group class="col-md-3 px-2" label="Método utilizado">
                  <b-form-select v-model="form.metodo_causa" :disabled="isSigned" size="sm">
                    <b-form-select-option :value="null">Seleccione...</b-form-select-option>
                    <b-form-select-option v-for="m in catalog.metodos_causa" :key="m" :value="m">{{ m }}</b-form-select-option>
                  </b-form-select>
                </b-form-group>
                <b-form-group class="col-md-9 px-2" label="Descripción"><b-form-input v-model="form.analisis_causa" :disabled="isSigned" size="sm" /></b-form-group>
              </div>

              <div class="d-flex justify-content-between align-items-center mt-2">
                <h5 class="mb-0">4. Plan de acción e implementación</h5>
              </div>
              <div v-for="(a, idx) in actions" :key="idx" class="border rounded p-2 mb-2">
                <div class="d-flex justify-content-between">
                  <strong class="small text-primary">Acción #{{ idx + 1 }}</strong>
                  <button type="button" class="btn btn-outline-danger btn-sm py-0" :disabled="isSigned" @click="removeAction(idx)"><i class="mdi mdi-trash-can"></i></button>
                </div>
                <div class="form-row">
                  <b-form-group class="col-md-6 px-2" label="Acción correctiva"><b-form-input v-model="a.accion" :disabled="isSigned" size="sm" /></b-form-group>
                  <b-form-group class="col-md-3 px-2" label="Responsable"><b-form-input v-model="a.responsable" :disabled="isSigned" size="sm" /></b-form-group>
                  <b-form-group class="col-md-3 px-2" label="Estado">
                    <b-form-select v-model="a.estado" :disabled="isSigned" size="sm">
                      <b-form-select-option v-for="s in catalog.estados" :key="s" :value="s">{{ s }}</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
                <div class="form-row align-items-end bg-light rounded py-1">
                  <b-form-group class="col-md-2 px-2" label="Inicio"><b-form-input type="date" v-model="a.fecha_inicio" :disabled="isSigned" size="sm" /></b-form-group>
                  <b-form-group class="col-md-2 px-2" label="Fin"><b-form-input type="date" v-model="a.fecha_fin" :disabled="isSigned" size="sm" /></b-form-group>
                  <b-form-group class="col-md-4 px-2" label="Recursos"><b-form-input v-model="a.recursos" :disabled="isSigned" size="sm" /></b-form-group>
                  <b-form-group class="col-md-4 px-2" label="Evidencia de ejecución">
                    <b-form-file :disabled="isSigned || a._uploading" browse-text="Buscar" :placeholder="a._uploading ? 'Subiendo...' : 'Selecciona...'" @change="onActionEvidence(a, $event)" size="sm" />
                  </b-form-group>
                  <div class="col-12 px-2 small" v-if="a.evidencia_file">
                    <a :href="a.evidencia_file" target="_blank"><i class="mdi mdi-paperclip"></i> {{ fileName(a.evidencia_file) }}</a>
                    <button v-if="!isSigned" type="button" class="btn btn-outline-danger btn-sm py-0 ml-1" @click="removeActionEvidence(a)"><i class="mdi mdi-close"></i></button>
                  </div>
                </div>
              </div>
              <button type="button" class="btn btn-outline-primary btn-sm mb-3" :disabled="isSigned" @click="addAction"><i class="mdi mdi-plus"></i> Agregar acción</button>

              <h5 class="mt-2">5. Verificación de eficacia</h5>
              <div class="form-row">
                <b-form-group class="col-md-3 px-2" label="¿La acción fue efectiva?">
                  <b-form-select v-model="form.eficacia" :disabled="isSigned" size="sm">
                    <b-form-select-option :value="null">Seleccione...</b-form-select-option>
                    <b-form-select-option v-for="ef in catalog.eficacias" :key="ef" :value="ef">{{ ef }}</b-form-select-option>
                  </b-form-select>
                </b-form-group>
                <b-form-group class="col-md-3 px-2" label="Estado del requerimiento">
                  <b-form-select v-model="form.estado" :disabled="isSigned" size="sm">
                    <b-form-select-option v-for="s in catalog.estados" :key="s" :value="s">{{ s }}</b-form-select-option>
                  </b-form-select>
                </b-form-group>
                <b-form-group class="col-md-6 px-2" label="Justificación"><b-form-input v-model="form.eficacia_justificacion" :disabled="isSigned" size="sm" /></b-form-group>
              </div>

              <h5 class="mt-2">6. Evidencias anexas</h5>
              <b-form-checkbox-group v-model="form.evidencias" :options="catalog.evidencias" :disabled="isSigned" class="small" />

              <h5 class="mt-3">7. Cierre</h5>
              <div class="form-row">
                <b-form-group class="col-md-3 px-2" label="Fecha de cierre"><b-form-input type="date" v-model="form.fecha_cierre" :disabled="isSigned" size="sm" /></b-form-group>
                <b-form-group class="col-md-3 px-2" label="Responsable del cierre"><b-form-input v-model="form.responsable_cierre" :disabled="isSigned" size="sm" /></b-form-group>
                <b-form-group class="col-md-3 px-2" label="Cargo"><b-form-input v-model="form.cargo_cierre" :disabled="isSigned" size="sm" /></b-form-group>
                <b-form-group class="col-md-3 px-2" label="Observaciones"><b-form-input v-model="form.observaciones" :disabled="isSigned" size="sm" /></b-form-group>
              </div>

              <div class="text-right mt-2">
                <button type="submit" :disabled="isSigned || submitting" class="btn btn-primary mx-1">Guardar</button>
                <button type="button" class="btn btn-secondary mx-1" @click="goBack">Cancelar</button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="col-lg-3" v-if="!loading && recordId">
        <h6 class="text-muted small mb-1">Requerimiento de Autoridad/ARL</h6>
        <DocumentActions
          :document-id="Number(recordId)"
          :company-id="companyID"
          :workflow-status="workflowStatus"
          :signed-at="signedAt"
          :api-service="recordApi"
          document-title="Implementación de Medidas y Acciones Correctivas de Autoridades y ARL"
          signer-role="gerente"
          @signed="onSigned"
        />
      </div>

      <div v-if="loading" class="col-12 text-center"><b-spinner variant="primary" label="Loading..."></b-spinner></div>
    </div>
  </Layout>
</template>
